/**
 * Gets query params.
 * @param {object} location
 * @returns {{isVehicleSelectorOpen: boolean, price: null|number}}
 */
export function getCalculatorUrlParams({ location }) {
  const searchParams = new URLSearchParams(location.search);

  const isVehicleSelectorOpen = searchParams.has('sv');
  const price = searchParams.get('calc_default_value');

  return { isVehicleSelectorOpen, price: price && Number(price) };
}
